export default __webpack_public_path__ + "static/media/yooz_pp.02e047a6.pdf";